import { render } from "./ConfirmPage.vue?vue&type=template&id=55cd7909&scoped=true"
import script from "./ConfirmPage.vue?vue&type=script&lang=js"
export * from "./ConfirmPage.vue?vue&type=script&lang=js"

import "./ConfirmPage.vue?vue&type=style&index=0&id=55cd7909&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55cd7909"]])

export default __exports__